import MobileModalFrame from "../common-components/mobile-modal-frame";
import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "Redux/hooks";
import CustomerPricingTab from "./customer-pricing-tab";

export default function CustomerPricingModal({ customerId, onHide }: { customerId: number | null; onHide: () => void }) {
  const { t } = useTranslation(["supplierPricing"]);
  const name = useAppSelector((s) => (customerId ? s.supplierPricing.customerPricing[customerId]?.customerName : ""));
  return (
    <Modal show={customerId !== null} onHide={onHide} centered size="lg" dialogClassName="eb-pr eb-pr-modal">
<MobileModalFrame onClose={onHide}>
      <div className="eb-pr-modal-body">
        <h2 className="eb-pr-modal-title">
          {t("customerTab.tabPricing")}
          {name ? ` · ${name}` : ""}
        </h2>
        {customerId !== null && <CustomerPricingTab customerId={customerId} onDone={onHide} />}
      </div>
    </MobileModalFrame>
</Modal>
  );
}
